import { createAsyncThunk } from "@reduxjs/toolkit";

import * as communicationService from "../../services/communication.service";

export const getDirectContacts = createAsyncThunk(
  "communication/getDirectContacts",
  async (_, { rejectWithValue }) => {
    try {
      return (await communicationService.getDirectContacts()) as any;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const getDirectConversation = createAsyncThunk(
  "communication/getDirectConversation",
  async (otherUserId: string, { rejectWithValue }) => {
    try {
      const messages = (await communicationService.getDirectConversation(
        otherUserId
      )) as any;
      return { otherUserId, messages };
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);

export const sendDirectMessage = createAsyncThunk(
  "communication/sendDirectMessage",
  async (
    payload: { recipientId: string; content: string },
    { dispatch, rejectWithValue }
  ) => {
    try {
      const response = (await communicationService.sendDirectMessage(payload)) as any;
      // Refresh the contact list so the preview/order stays in sync.
      dispatch(getDirectContacts());
      return response;
    } catch (error: any) {
      return rejectWithValue(error);
    }
  }
);
